import { createRouter, createWebHistory } from 'vue-router'
import { checkAdminUserWithId } from '@/services/adminUserService';
import { getUser } from '@/utilities/helpers.js';
import Swal from 'sweetalert2';
import i18n from '@/i18n';
const t = i18n.global.t;
//can use translation if needed

// Design System Routes
// const designSystemChildRoutes = (prefix) => [
//   {
//     path: '',
//     name: prefix + '.main',
//     meta: { auth: true, name: 'Design System' },
//     component: () => import('@/views/design-system/IndexPage.vue')
//   }
// ]
// Auth Default Routes
const authChildRoutes = (prefix) => [
  {
    path: 'login',
    name: prefix + '.login',
    meta: { auth: false, name: 'Login' },
    component: () => import('@/views/auth/default/SignIn.vue')
  },
  {
    path: 'register',
    name: prefix + '.register',
    meta: { auth: false, name: 'Register' },
    component: () => import('@/views/auth/default/SignUp.vue')
  },
  {
    path: 'reset-password',
    name: prefix + '.reset-password',
    meta: { auth: false, name: 'Reset Password' },
    component: () => import('@/views/auth/default/ResetPassword.vue')
  },
  {
    path: 'set-password',
    name: prefix + '.set-password',
    meta: { auth: false, name: 'Set Password' },
    component: () => import('@/views/auth/default/SetPassword.vue')
  },
  {
    path: 'verify-email',
    name: prefix + '.verify-email',
    meta: { auth: false, name: 'Verify Email' },
    component: () => import('@/views/auth/default/VarifyEmail.vue')
  },
  {
    path: 'lock-screen',
    name: prefix + '.lock-screen',
    meta: { auth: false, name: 'Lock Screen' },
    component: () => import('@/views/auth/default/LockScreen.vue')
  }
]

// Dashboard routes
const dashboardRoutes = (prefix) => [
  {
    path: '',
    name: prefix + '.dashboard',
    meta: { auth: true, authName: "DASHBOARD_VIEW", name: 'Dashboard', isBanner: false, breadcrumb: 'Home' },
    component: () => import('@/views/dashboards/IndexPage.vue')
  }
]
// Default routes
const defaultChildRoutes = (prefix) => [
  {
    path: '',
    name: prefix + '.dashboard',
    meta: { auth: true, authName: "DASHBOARD_VIEW", name: t('dashboard'), isBanner: true, breadcrumb: t('home') },
    component: () => import('@/views/dashboards/IndexPage.vue'),
  },
  // Extra Pages
  {
    path: '/user-management',
    name: prefix + '.user-management',
    meta: { auth: true, name: t('user-management'), isBanner: true, breadcrumb: t('user-management') },
    component: () => import('@/views/user-management/index.vue'),
    redirect: { name: prefix + '.user-management.department' },
    children: [
      {
        path: 'department',
        name: prefix + '.user-management.department',
        meta: { auth: true, authName: "DEPARTMENT_VIEW", name: t('department'), isBanner: true, breadcrumb: t('department') },
        component: () => import('@/views/user-management/department/index.vue'),
        children: [
          {
            path: 'add-department',
            name: prefix + '.user-management.department.add',
            meta: { auth: true, authName: "DEPARTMENT_CREATE", name: t('add-dept'), isBanner: true, breadcrumb: t('add-dept') },
            component: () => import('@/views/user-management/department/department-add.vue')
          },
          {
            path: 'edit-department/:id',
            name: prefix + '.user-management.department.edit',
            meta: { auth: true, authName: "DEPARTMENT_UPDATE", name: t('edit-dept'), isBanner: true, breadcrumb: t('edit-dept') },
            component: () => import('@/views/user-management/department/department-edit.vue'),
            props: true
          },
          {
            path: 'view-department/:id',
            name: prefix + '.user-management.department.view',
            meta: { auth: true, authName: "DEPARTMENT_VIEW", name: t('view-dept'), isBanner: true, breadcrumb: t('view-dept') },
            component: () => import('@/views/user-management/department/department-view.vue'),
            props: true
          }
        ]
      },

      {
        path: 'admin-user',
        name: prefix + '.user-management.admin-user',
        meta: { auth: true, authName: "ADMIN_VIEW", name: t('admin-user'), isBanner: true, breadcrumb: t('admin-user') },
        component: () => import('@/views/user-management/admin-user/index.vue'),
        children: [
          {
            path: 'add-admin-user',
            name: prefix + '.user-management.admin-user.add',
            meta: { auth: true, authName: "ADMIN_CREATE", name: t('add-admin'), isBanner: true, breadcrumb: t('add-admin') },
            component: () => import('@/views/user-management/admin-user/admin-user-add.vue')
          },
          {
            path: 'edit-admin-user/:id',
            name: prefix + '.user-management.admin-user.edit',
            meta: { auth: true, authName: "ADMIN_UPDATE", name: t('edit-admin'), isBanner: true, breadcrumb: t('edit-admin') },
            component: () => import('@/views/user-management/admin-user/admin-user-edit.vue'),
            props: true
          },
          {
            path: 'view-admin-user/:id',
            name: prefix + '.user-management.admin-user.view',
            meta: { auth: true, authName: "ADMIN_VIEW", name: t('view-admin'), isBanner: true, breadcrumb: t('view-admin') },
            component: () => import('@/views/user-management/admin-user/admin-user-view.vue'),
            props: true
          },
        ]
      },
      {
        path: 'role',
        name: prefix + '.user-management.role',
        meta: { auth: true, authName: "ADMIN_VIEW", name: t('role'), isBanner: true, breadcrumb: t('role') },
        component: () => import('@/views/user-management/role/index.vue'),
        children: [
          {
            path: 'add-role',
            name: prefix + '.user-management.role.add',
            meta: { auth: true, authName: "ADMIN_CREATE", name: t('add-role'), isBanner: true, breadcrumb: t('add-role') },
            component: () => import('@/views/user-management/role/role-add.vue')
          },
          {
            path: 'edit-role/:id',
            name: prefix + '.user-management.role.edit',
            meta: { auth: true, authName: "ADMIN_UPDATE", name: t('edit-role'), isBanner: true, breadcrumb: t('edit-role') },
            component: () => import('@/views/user-management/role/role-edit.vue'),
            props: true
          },
          {
            path: 'view-role/:id',
            name: prefix + '.user-management.role.view',
            meta: { auth: true, authName: "ADMIN_VIEW", name: t('view-role'), isBanner: true, breadcrumb: t('view-role') },
            component: () => import('@/views/user-management/role/role-view.vue'),
            props: true
          },
        ]
      },
      {
        path: 'organizer',
        name: prefix + '.user-management.organizer',
        meta: { auth: true, name: t('organizer'), isBanner: true, breadcrumb: t('organizer') },
        component: () => import('@/views/user-management/organizer/index.vue')
      }
    ]
  },
  {
    path: '/venue-management',
    name: prefix + '.venue-management',
    meta: { auth: true, name: t('venue-management'), isBanner: true, breadcrumb: t('venue-management') },
    component: () => import('@/views/venue-management/index.vue'),
    redirect: { name: prefix + '.venue-management.facility' },
    children: [
      {
        path: 'facility',
        name: prefix + '.venue-management.facility',
        meta: { auth: true, name: t('facility'), isBanner: true, breadcrumb: t('facility') },
        component: () => import('@/views/venue-management/facility/index.vue'),
        children: [
          {
            path: 'add-facility',
            name: prefix + '.venue-management.facility.add',
            meta: { auth: true, name: t('add-facility'), isBanner: true, breadcrumb: t('add-facility') },
            component: () => import('@/views/venue-management/facility/facility-add.vue')
          },
          {
            path: 'edit-facility/:id',
            name: prefix + '.venue-management.facility.edit',
            meta: { auth: true, name: t('edit-facility'), isBanner: true, breadcrumb: t('edit-facility') },
            component: () => import('@/views/venue-management/facility/facility-edit.vue'),
            props: true
          },
          {
            path: 'view-facility/:id',
            name: prefix + '.venue-management.facility.view',
            meta: { auth: true, name: t('view-facility'), isBanner: true, breadcrumb: t('view-facility') },
            component: () => import('@/views/venue-management/facility/facility-view.vue'),
            props: true
          },
        ]
      },
      {
        path: 'layout',
        name: prefix + '.venue-management.layout',
        meta: { auth: true, name: t('layout'), isBanner: true, breadcrumb: t('layout') },
        component: () => import('@/views/venue-management/layout/index.vue'),
        children: [
          {
            path: 'add-layout',
            name: prefix + '.venue-management.layout.add',
            meta: { auth: true, name: t('add-layout'), isBanner: true, breadcrumb: t('add-layout') },
            component: () => import('@/views/venue-management/layout/layout-add.vue')
          },
          {
            path: 'edit-layout/:id',
            name: prefix + '.venue-management.layout.edit',
            meta: { auth: true, name: t('edit-layout'), isBanner: true, breadcrumb: t('edit-layout') },
            component: () => import('@/views/venue-management/layout/layout-edit.vue'),
            props: true
          },
          {
            path: 'view-layout/:id',
            name: prefix + '.venue-management.layout.view',
            meta: { auth: true, name: t('view-layout'), isBanner: true, breadcrumb: t('view-layout') },
            component: () => import('@/views/venue-management/layout/layout-view.vue'),
            props: true
          },
        ]
      },
      {
        path: 'venue',
        name: prefix + '.venue-management.venue',
        meta: { auth: true, authName: "VENUE_VIEW", name: t('venue'), isBanner: true, breadcrumb: t('venue') },
        component: () => import('@/views/venue-management/venue/index.vue'),
        children: [
          {
            path: 'add-venue',
            name: prefix + '.venue-management.venue.add',
            meta: { auth: true, authName: "VENUE_CREATE", name: t('create-venue'), isBanner: true, breadcrumb: t('create-venue') },
            component: () => import('@/views/venue-management/venue/venue-add.vue')
          },
          {
            path: 'edit-venue/:id',
            name: prefix + '.venue-management.venue.edit',
            meta: { auth: true, authName: "VENUE_UPDATE", name: t('edit-venue'), isBanner: true, breadcrumb: t('edit-venue') },
            component: () => import('@/views/venue-management/venue/venue-edit.vue'),
            props: true
          },
          {
            path: 'view-venue/:id',
            name: prefix + '.venue-management.venue.view',
            meta: { auth: true, authName: "VENUE_VIEW", name: t('view-venue'), isBanner: true, breadcrumb: t('view-venue') },
            component: () => import('@/views/venue-management/venue/venue-view.vue'),
            props: true
          },
        ]
      }
    ]
  },
  {
    path: '/admin-permissions',
    name: prefix + '.admin-permissions',
    meta: { auth: true, name: t('admin'), isBanner: true, breadcrumb: t('admin') },
    component: () => import('@/views/admin/AdminPage.vue')
  },

  //Member Management
  {
    path: '/member-management',
    name: prefix + '.member-management',
    meta: { auth: true, authName: "USER_VIEW", name: t('member-management'), isBanner: true, breadcrumb: t('member-management') },
    component: () => import('@/views/member-management/index.vue'),
    children: [
      {
        path: '',
        name: prefix + '.member-management.listing',
        meta: { auth: true, authName: "USER_VIEW", name: t('member'), isBanner: true, breadcrumb: t('member') },
        component: () => import('@/views/member-management/member-management-listing.vue'),
        children: [
          {
            path: 'add-member-management',
            name: prefix + '.member-management.add',
            meta: { auth: true, authName: "USER_CREATE", name: t('create-member-user'), isBanner: true, breadcrumb: t('create-member-user') },
            component: () => import('@/views/member-management/member-management-add.vue')
          },

          {
            path: 'view-member-management/:id',
            name: prefix + '.member-management.view',
            meta: { auth: true, authName: "USER_VIEW", name: t('view-member-user'), isBanner: true, breadcrumb: t('view-member-user') },
            component: () => import('@/views/member-management/member-management-view.vue')
          },
          {
            path: 'edit-member-management/:id',
            name: prefix + '.member-management.edit',
            meta: { auth: true, authName: "USER_UPDATE", name: t('edit-member-user'), isBanner: true, breadcrumb: t('edit-member-user') },
            component: () => import('@/views/member-management/member-management-edit.vue')
          },
        ]
      },
    ]
  },

  //Ticket Management
  {
    path: '/ticket-management',
    name: prefix + '.ticket-management',
    meta: { auth: true, name: t('ticket-management'), isBanner: true, breadcrumb: t('ticket-management') },
    component: () => import('@/views/ticket-management/index.vue'),
    redirect: { name: prefix + '.ticket-management' },
    children: [
      {
        path: 'ticket',
        name: prefix + '.ticket-management.ticket',
        meta: { auth: true, authName: "TICKET_VIEW", name: t('ticket'), isBanner: true, breadcrumb: t('ticket') },
        component: () => import('@/views/ticket-management/ticket/index.vue'),
        children: [
          {
            path: 'add-ticket',
            name: prefix + '.ticket-management.ticket.add',
            meta: { auth: true, authName: "TICKET_CREATE", name: 'Add Ticket', isBanner: true, breadcrumb: 'Add Ticket' },
            component: () => import('@/views/ticket-management/ticket/ticket-add.vue')
          },
          {
            path: 'edit-ticket',
            name: prefix + '.ticket-management.ticket.edit',
            meta: { auth: true, authName: "TICKET_UPDATE", name: 'Edit Ticket', isBanner: true, breadcrumb: 'Edit Ticket' },
            component: () => import('@/views/ticket-management/ticket/ticket-edit.vue')
          },
          {
            path: 'view-ticket/:id',
            name: prefix + '.ticket-management.ticket.view',
            meta: { auth: true, authName: "TICKET_VIEW", name: t('view-ticket'), isBanner: true, breadcrumb: t('view-ticket') },
            component: () => import('@/views/ticket-management/ticket/ticket-view.vue')
          },

        ]
      },
      {
        path: 'scan-history',
        name: prefix + '.ticket-management.scan-history',
        meta: { auth: true, authName: "TICKET_SCAN_HISTORY_VIEW", name: t('ticket-scan-history'), isBanner: true, breadcrumb: t('ticket-scan-history') },
        component: () => import('@/views/ticket-management/ticket-scan-history/index.vue'),
        children: [
          {
            path: 'scan-history-view/:id',
            name: prefix + '.ticket-management.scan-history.view',
            meta: { auth: true, authName: "TICKET_SCAN_HISTORY_VIEW", name: t('view-ticket-scan-history'), isBanner: true, breadcrumb: t('view-ticket-scan-history') },
            component: () => import('@/views/ticket-management/ticket-scan-history/ticket-scan-history-view.vue')
          },

        ]
      },
      {
        path: 'refund-in-process',
        name: prefix + '.ticket-management.refund-in-process',
        meta: { auth: true, authName: "TICKET_RIP_VIEW", name: t('refund-in-process'), isBanner: true, breadcrumb: t('refund-in-process') },
        component: () => import('@/views/ticket-management/refund-in-process/index.vue'),
      },
    ],
  },

  // Announcement
  {
    path: '/announcement',
    name: prefix + '.announcement',
    meta: { auth: true, authName: "ANNOUNCEMENT_VIEW", name: t('announcement'), isBanner: true, breadcrumb: t('announcement-list') },
    component: () => import('@/views/announcement/index.vue'),
    children: [
      {
        path: 'add-announcement',
        name: prefix + '.announcement.add',
        meta: { auth: true, authName: "ANNOUNCEMENT_CREATE", name: t('create-announcement'), isBanner: true, breadcrumb: t('create-announcement') },
        component: () => import('@/views/announcement/announcement-add.vue')
      },
      {
        path: 'edit-announcement/:id',
        name: prefix + '.announcement.edit',
        meta: { auth: true, authName: "ANNOUNCEMENT_UPDATE", name: t('edit-announcement'), isBanner: true, breadcrumb: t('edit-announcement') },
        component: () => import('@/views/announcement/announcement-edit.vue'),
        props: true
      },
      {
        path: 'view-announcement/:id',
        name: prefix + '.announcement.view',
        meta: { auth: true, authName: "ANNOUNCEMENT_VIEW", name: t('view-announcement'), isBanner: true, breadcrumb: t('view-announcement') },
        component: () => import('@/views/announcement/announcement-view.vue'),
        props: true
      },
    ],
  },

  //Event Management
  {
    path: '/event-management',
    name: prefix + '.event-management',
    meta: { auth: true, name: t('event-management'), isBanner: true, breadcrumb: t('event-management') },
    component: () => import('@/views/event-management/index.vue'),
    redirect: { name: prefix + '.event-management' },
    children: [
      {
        path: 'event-category',
        name: prefix + '.event-management.event-category',
        meta: { auth: true, authName: "EVENT_CATEGORY_VIEW", name: t('event-category'), isBanner: true, breadcrumb: t('event-category') },
        component: () => import('@/views/event-management/event-category/index.vue'),
        children: [
          {
            path: 'add-event-category',
            name: prefix + '.event-management.event-category.add',
            meta: { auth: true, authName: "EVENT_CATEGORY_CREATE", name: t('create-event-category'), isBanner: true, breadcrumb: t('create-event-category') },
            component: () => import('@/views/event-management/event-category/event-category-add.vue')
          },

          {
            path: 'edit-event-category/:id',
            name: prefix + '.event-management.event-category.edit',
            meta: { auth: true, authName: "EVENT_CATEGORY_UPDATE", name: t('edit-event-category'), isBanner: true, breadcrumb: t('edit-event-category') },
            component: () => import('@/views/event-management/event-category/event-category-edit.vue'),
            props: true
          },

          {
            path: 'view-event-category/:id',
            name: prefix + '.event-management.event-category.view',
            meta: { auth: true, authName: "EVENT_CATEGORY_VIEW", name: t('view-event-category'), isBanner: true, breadcrumb: t('view-event-category') },
            component: () => import('@/views/event-management/event-category/event-category-view.vue'),
            props: true
          },
        ]
      },

      //Tag
      {
        path: 'tag',
        name: prefix + '.event-management.tag',
        meta: { auth: true, authName: "EVENT_TAG_VIEW", name: t('tag'), isBanner: true, breadcrumb: t('tag') },
        component: () => import('@/views/event-management/tag/index.vue'),
        children: [
          {
            path: 'add-tag',
            name: prefix + '.event-management.tag.add',
            meta: { auth: true, authName: "EVENT_TAG_CREATE", name: t('create-tag'), isBanner: true, breadcrumb: t('create-tag') },
            component: () => import('@/views/event-management/tag/tag-add.vue')
          },

          {
            path: 'edit-tag/:id',
            name: prefix + '.event-management.tag.edit',
            meta: { auth: true, authName: "EVENT_TAG_UPDATE", name: t('edit-tag'), isBanner: true, breadcrumb: t('edit-tag') },
            component: () => import('@/views/event-management/tag/tag-edit.vue'),
            props: true
          },

          {
            path: 'view-tag/:id',
            name: prefix + '.event-management.tag.view',
            meta: { auth: true, authName: "EVENT_TAG_VIEW", name: t('view-tag'), isBanner: true, breadcrumb: t('view-tag') },
            component: () => import('@/views/event-management/tag/tag-view.vue'),
            props: true
          },
        ]
      },

      {
        path: 'event-list',
        name: prefix + '.event-management.event',
        meta: { auth: true, authName: "EVENT_VIEW", name: t('event'), isBanner: true, breadcrumb: t('event') },
        component: () => import('@/views/event-management/event/index.vue'),
        children: [
          {
            path: 'add-event',
            name: prefix + '.event-management.event.add',
            meta: { auth: true, authName: "EVENT_CREATE", name: t('create-event'), isBanner: true, breadcrumb: t('create-event') },
            component: () => import('@/views/event-management/event/event-add.vue')
          },
          {
            path: 'edit-event/:id',
            name: prefix + '.event-management.event.edit',
            meta: { auth: true, authName: "EVENT_UPDATE", name: t('edit-event'), isBanner: true, breadcrumb: t('edit-event') },
            component: () => import('@/views/event-management/event/event-edit.vue'),
            props: true
          },
          {
            path: 'view-event/:id',
            name: prefix + '.event-management.event.view',
            meta: { auth: true, authName: "EVENT_VIEW", name: t('view-event'), isBanner: true, breadcrumb: t('view-event') },
            component: () => import('@/views/event-management/event/event-view.vue'),
            props: true
          },
        ]
      },

      {
        path: 'feature-event',
        name: prefix + '.event-management.feature-event',
        meta: { auth: true, authName: "FEATURE_EVENT_VIEW", name: t('feature-event'), isBanner: true, breadcrumb: t('feature-event') },
        component: () => import('@/views/event-management/feature-event/index.vue'),
      },

      {
        path: 'feature-banner',
        name: prefix + '.event-management.feature-banner',
        meta: { auth: true, authName: "BANNER_EVENT_VIEW", name: t('feature-banner'), isBanner: true, breadcrumb: t('feature-banner') },
        component: () => import('@/views/event-management/feature-banner/index.vue'),
      },
    ],
  },

  //Protion and discount
  {
    path: '/promotion-and-discount',
    name: prefix + '.promotion-and-discount',
    meta: { auth: true, name: t('promotion-and-discount'), isBanner: true, breadcrumb: t('promotion-and-discount') },
    component: () => import('@/views/promotion-and-discount/index.vue'),
    redirect: { name: prefix + '.promotion-and-discount' },
    children: [
      {
        path: 'promotion-and-discount',
        name: prefix + '.promotion-and-discount.promotion',
        meta: { auth: true, authName: "PROMOTION_VIEW", name: t('promotion'), isBanner: true, breadcrumb: t('promotion') },
        component: () => import('@/views/promotion-and-discount/promotion/index.vue'),
        children: [
          {
            path: 'add-promotion',
            name: prefix + '.promotion-and-discount.promotion.add',
            meta: { auth: true, authName: "PROMOTION_CREATE", name: t('create-promotion'), isBanner: true, breadcrumb: t('create-promotion') },
            component: () => import('@/views/promotion-and-discount/promotion/promotion-add.vue')
          },

          {
            path: 'edit-promotion/:id',
            name: prefix + '.promotion-and-discount.promotion.edit',
            meta: { auth: true, authName: "PROMOTION_UPDATE", name: t('edit-promotion'), isBanner: true, breadcrumb: t('edit-promotion') },
            component: () => import('@/views/promotion-and-discount/promotion/promotion-edit.vue'),
            props: true
          },

          {
            path: 'view-promotion/:id',
            name: prefix + '.promotion-and-discount.promotion.view',
            meta: { auth: true, authName: "PROMOTION_VIEW", name: t('view-promotion'), isBanner: true, breadcrumb: t('view-promotion') },
            component: () => import('@/views/promotion-and-discount/promotion/promotion-view.vue'),
            props: true
          },
        ],
      }
    ]
  },

  //Customer Support
  {
    path: '/customer-support',
    name: prefix + '.customer-support',
    meta: { auth: true, name: t('customer-support'), isBanner: true, breadcrumb: t('customer-support') },
    component: () => import('@/views/customer-support/index.vue'),
    redirect: { name: prefix + '.customer-support' },
    children: [
      {
        path: 'faq-content',
        name: prefix + '.customer-support.faq-content',
        meta: { auth: true, authName: "FAQ_CONTENT_VIEW", name: t('faq-content'), isBanner: true, breadcrumb: t('faq-content') },
        component: () => import('@/views/customer-support/faq-content/index.vue'),
        children: [
          {
            path: 'add-faq-content',
            name: prefix + '.customer-support.faq-content.add',
            meta: { auth: true, authName: "FAQ_CONTENT_CREATE", name: t('create-faq-content'), isBanner: true, breadcrumb: t('create-faq-content') },
            component: () => import('@/views/customer-support/faq-content/faq-content-add.vue')
          },

          {
            path: 'edit-faq-content/:id',
            name: prefix + '.customer-support.faq-content.edit',
            meta: { auth: true, authName: "FAQ_CONTENT_UPDATE", name: t('edit-faq-content'), isBanner: true, breadcrumb: t('edit-faq-content') },
            component: () => import('@/views/customer-support/faq-content/faq-content-edit.vue'),
            props: true
          },

          {
            path: 'view-faq-content/:id',
            name: prefix + '.customer-support.faq-content.view',
            meta: { auth: true, authName: "FAQ_CONTENT_VIEW", name: t('view-faq-content'), isBanner: true, breadcrumb: t('view-faq-content') },
            component: () => import('@/views/customer-support/faq-content/faq-content-view.vue'),
            props: true
          },
        ],
      },
      {
        path: 'faq-category',
        name: prefix + '.customer-support.faq-category',
        meta: { auth: true, authName: "FAQ_CATEGORY_VIEW", name: t('faq-category'), isBanner: true, breadcrumb: t('faq-category') },
        component: () => import('@/views/customer-support/faq-category/index.vue'),
        children: [
          {
            path: 'add-faq-category',
            name: prefix + '.customer-support.faq-category.add',
            meta: { auth: true, authName: "FAQ_CATEGORY_CREATE", name: t('create-faq-category'), isBanner: true, breadcrumb: t('create-faq-category') },
            component: () => import('@/views/customer-support/faq-category/faq-category-add.vue')
          },
          {
            path: 'edit-faq-category/:id',
            name: prefix + '.customer-support.faq-category.edit',
            meta: { auth: true, authName: "FAQ_CATEGORY_UPDATE", name: t('edit-faq-category'), isBanner: true, breadcrumb: t('edit-faq-category') },
            component: () => import('@/views/customer-support/faq-category/faq-category-edit.vue'),
            props: true
          },
          {
            path: 'view-faq-category/:id',
            name: prefix + '.customer-support.faq-category.view',
            meta: { auth: true, authName: "FAQ_CATEGORY_VIEW", name: t('view-faq-category'), isBanner: true, breadcrumb: t('view-faq-category') },
            component: () => import('@/views/customer-support/faq-category/faq-category-view.vue'),
            props: true
          },
        ]
      },

      {
        path: 'request',
        name: prefix + '.customer-support.request',
        meta: { auth: true, authName: "REQUEST_VIEW", name: t('request'), isBanner: true, breadcrumb: t('request') },
        component: () => import('@/views/customer-support/request/index.vue'),
        children: [
          {
            path: 'add-request',
            name: prefix + '.customer-support.request.add',
            meta: { auth: true, authName: "REQUEST_CREATE", name: t('create-request'), isBanner: true, breadcrumb: t('create-request') },
            component: () => import('@/views/customer-support/request/request-add.vue')
          },
          {
            path: 'edit-request/:id',
            name: prefix + '.customer-support.request.edit',
            meta: { auth: true, authName: "REQUEST_UPDATE", name: t('edit-request'), isBanner: true, breadcrumb: t('edit-request') },
            component: () => import('@/views/customer-support/request/request-edit.vue')
          },
          {
            path: 'view-request/:id',
            name: prefix + '.customer-support.request.view',
            meta: { auth: true, authName: "REQUEST_VIEW", name: t('view-request'), isBanner: true, breadcrumb: t('view-request') },
            component: () => import('@/views/customer-support/request/request-view.vue')
          },
        ]
      },

      {
        path: 'site-owner',
        name: prefix + '.customer-support.site-owner',
        meta: { auth: true, authName: "CONTACT_INFO_VIEW", name: t('site-owner'), isBanner: true, breadcrumb: t('site-owner') },
        component: () => import('@/views/customer-support/site-owner/index.vue'),
      },
    ]
  },

  {
    path: '/audit-trail',
    name: prefix + '.audit-trail',
    meta: { auth: true, authName: "AUDIT_TRAIL_VIEW", name: t('audit-trail'), isBanner: true, breadcrumb: t('audit-trail') },
    component: () => import('@/views/audit-trail/index.vue'),
    children: [
      {
        path: '', name: prefix + '.audit-trail.listing', meta: { auth: true, authName: 'AUDIT_TRAIL_VIEW', name: t('audit-trail-listing'), breadcrumb: t('audit-trail-listing') },
        component: () => import('@/views/audit-trail/audit-trail-listing.vue'),
        children: [
          {
            path: 'view-audit-trail/:id',
            name: prefix + '.audit-trail.view',
            meta: { auth: true, authName: "AUDIT_TRAIL_VIEW", name: t('view-audit-trail'), isBanner: true, breadcrumb: t('view-audit-trail') },
            component: () => import('@/views/audit-trail/audit-trail-view.vue'),
            props: true
          }
        ]
      },
    ],
  },

  //website rating
  {
    path: '/website-rating',
    name: prefix + '.website-rating',
    meta: { auth: true, name: t('website-rating'), isBanner: true, breadcrumb: t('website-rating') },
    component: () => import('@/views/website-rating/index.vue'),
    children: [
      {
        path: 'order', name: prefix + '.website-rating.order', meta: { auth: true, authName: 'WEBSITE_SATISFACTION_RATING_VIEW', name: t('website-rating-order'), breadcrumb: t('website-rating-order') },
        component: () => import('@/views/website-rating/website-rating-order/index.vue'),
      },
      {
        path: 'faq', name: prefix + '.website-rating.faq', meta: { auth: true, authName: 'WEBSITE_FAQ_RATING_VIEW', name: t('website-rating-faq'), breadcrumb: t('website-rating-faq') },
        component: () => import('@/views/website-rating/website-rating-faq/index.vue'),
      },
    ],
  },

  {
    path: '/user-manual',
    name: prefix + '.user-manual',
    meta: { auth: true, authName: "USER_MANUAL_VIEW", name: t('user-manual'), isBanner: true, breadcrumb: t('user-manual') },
    component: () => import('@/views/user-manual/index.vue'),
    children: [
      {
        path: 'user-manual', name: prefix + '.user-manual.listing', meta: { auth: true, authName: 'USER_MANUAL_VIEW', name: t('user-manual-listing'), breadcrumb: t('user-manual-listing') },
        component: () => import('@/views/user-manual/user-manual-listing.vue'),
        // children: [
        //   {
        //     path: 'view-audit-trail/:id',
        //     name: prefix + '.audit-trail.view',
        //     meta: { auth: true, authName: "AUDIT_TRAIL_VIEW", name: t('view-audit-trail'), isBanner: true, breadcrumb: t('view-audit-trail') },
        //     component: () => import('@/views/audit-trail/audit-trail-view.vue'),
        //     props: true
        //   }
        // ]
      },
    ],
  },

  //Device Management
  // {
  //   path: '/device-management',
  //   name: prefix + '.device-management',
  //   meta: { auth: true, name: t('device-management'), isBanner: true, breadcrumb: t('device-management') },
  //   component: () => import('@/views/device-management/index.vue'),
  //   redirect: { name: prefix + '.device-management' },
  //   children: [
  //     {
  //       path: 'device-management',
  //       name: prefix + '.device-management.device',
  //       meta: { auth: true, authName: "DEVICE_VIEW", name: t('device'), isBanner: true, breadcrumb: t('device') },
  //       component: () => import('@/views/device-management/device/index.vue'),
  //       children: [
  //         {
  //           path: 'add-device',
  //           name: prefix + '.device-management.device.add',
  //           meta: { auth: true, authName: "DEVICE_CREATE", name: t('add-device'), isBanner: true, breadcrumb: t('add-device') },
  //           component: () => import('@/views/device-management/device/device-add.vue')
  //         },
  //         {
  //           path: 'view-device/:id',
  //           name: prefix + '.device-management.device.view',
  //           meta: { auth: true, authName: "DEVICE_VIEW", name: t('view-device'), isBanner: true, breadcrumb: t('view-device') },
  //           component: () => import('@/views/device-management/device/device-view.vue'),
  //           props: true
  //         },
  //         {
  //           path: 'edit-device/:id',
  //           name: prefix + '.device-management.device.edit',
  //           meta: { auth: true, authName: "DEVICE_UPDATE", name: t('edit-device'), isBanner: true, breadcrumb: t('edit-device') },
  //           component: () => import('@/views/device-management/device/device-edit.vue'),
  //           props: true
  //         },
  //       ],
  //     },
  //   ]
  // },

  {
    path: '/reporting',
    name: prefix + '.reporting',
    meta: { auth: true, name: t('reporting'), isBanner: true, breadcrumb: t('reporting') },
    component: () => import('@/views/reporting/index.vue'),
    redirect: { name: prefix + '.reporting' },
    children: [
      {
        path: 'sales-report',
        name: prefix + '.reporting.sales-report',
        meta: { auth: true, authName: "SALES_REPORT_VIEW", name: t('sales-report'), isBanner: true, breadcrumb: t('sales-report') },
        component: () => import('@/views/reporting/sales-report/index.vue'),
      },
      {
        path: 'event-report',
        name: prefix + '.reporting.event-report',
        meta: { auth: true, authName: "EVENT_REPORT_VIEW", name: t('event-report'), isBanner: true, breadcrumb: t('event-report') },
        component: () => import('@/views/reporting/event-report/index.vue'),
      },
    ]
  },

  //payment record
  {
    path: '/payment-record',
    name: prefix + '.payment-record',
    meta: { auth: true, authName: "PAYMENT_RECORD_VIEW", name: t('payment-record'), isBanner: true, breadcrumb: t('payment-record-listing') },
    component: () => import('@/views/payment-record/index.vue')
  },
]





const errorRoutes = (prefix) => [
  // Error Pages
  {
    path: '404',
    name: prefix + '.404',
    meta: { auth: false, name: 'Error 404', isBanner: true },
    component: () => import('@/views/errors/Error404Page.vue')
  },
  {
    path: '500',
    name: prefix + '.500',
    meta: { auth: false, name: 'Error 500', isBanner: true },
    component: () => import('@/views/errors/Error500Page.vue')
  },
  {
    path: 'maintenance',
    name: prefix + '.maintenance',
    meta: { auth: false, name: 'Maintenance', isBanner: true },
    component: () => import('@/views/errors/MaintenancePage.vue')
  }
]

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  // Default Pages
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../layouts/DefaultLayout.vue'),
    children: defaultChildRoutes('default')
  },
  // Menu Styles
  {
    path: '/horizontal',
    name: 'horizontal',
    component: () => import('../layouts/menu-styles/HorizontalLayout.vue'),
    children: dashboardRoutes('horizontal')
  },
  {
    path: '/dual-horizontal',
    name: 'dual-horizontal',
    component: () => import('../layouts/menu-styles/DualHorizontalLayout.vue'),
    children: dashboardRoutes('dual-horizontal')
  },
  {
    path: '/dual-compact',
    name: 'dual-compact',
    component: () => import('../layouts/menu-styles/DualCompactLayout.vue'),
    children: dashboardRoutes('dual-compact')
  },
  {
    path: '/boxed',
    name: 'boxed',
    component: () => import('../layouts/menu-styles/BoxedLayout.vue'),
    children: dashboardRoutes('boxed')
  },
  {
    path: '/boxed-fancy',
    name: 'boxed-fancy',
    component: () => import('../layouts/menu-styles/BoxedFancyLayout.vue'),
    children: dashboardRoutes('boxed-fancy')
  },

  // Auth Skins
  {
    path: '/auth',
    name: 'auth',
    component: () => import('../layouts/guest/BlankLayout.vue'),
    children: authChildRoutes('auth')
  },
  // Errors Pages
  {
    path: '/errors',
    name: 'errors',
    component: () => import('../layouts/guest/BlankLayout.vue'),
    children: errorRoutes('errors')
  },
  // Catch-all route for 404
  {
    path: '/:pathMatch(.*)*', // Vue Router 4 syntax for wildcard
    name: 'NotFound',
    component: () => import('@/views/errors/Error404Page.vue'),
    meta: { auth: false, name: 'Error 404', isBanner: false }
  }
]

const router = createRouter({
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  let isUserTokenValid = isUserLoggedIn();
  let isUserHasPermission = await checkUserPermission(to.meta.authName);
  let hasToken = JSON.parse(localStorage.getItem('hasToken') || false);

  if (to.meta.auth && !isUserTokenValid) {
    if (!hasToken) {
      return next('/auth/login');
    } else {
      return Swal.fire({
        icon: 'error',
        title: 'Session Has Expired!',
        text: 'Please login again to resume the session.',
        confirmButtonText: 'OK',
      }).then(() => {
        localStorage.clear();
        sessionStorage.clear();
        next('/auth/login'); // Navigate only after user clicks OK
      });
    }

  } else if (to.meta.auth && (!isUserHasPermission)) {
    return Swal.fire({
      icon: 'error',
      title: 'Access Denied',
      text: 'You do not have permission to access this page.',
      confirmButtonText: 'OK',
    }).then(() => {
      next('/dashboard'); // Navigate only after user clicks OK
    });
  } else if (!to.meta.auth) {
    next();
  }

  next(); // Allow navigation if everything is valid
});

function isUserLoggedIn() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const tokenExpiration = localStorage.getItem('tokenExpiration');

  if (!token || !tokenExpiration) {
    localStorage.setItem('hasToken', JSON.stringify(false));
    return false; // No token or expiration found
  }

  // Convert expiration time to a Date object
  const expirationDate = new Date(tokenExpiration);
  const currentDate = new Date();

  // If the token has expired, return false
  return currentDate < expirationDate;
}

async function checkUserPermission(authName) {
  if (!authName) return false;

  const user = getUser();
  if (!user || !user.id) {
    return false;
  }

  try {
    const response = await checkAdminUserWithId(user.id);
    const responseData = response.data;

    localStorage.setItem('user', JSON.stringify(responseData));

    const permissionList = responseData.permissions || [];

    localStorage.setItem('permissionList', JSON.stringify(permissionList));

    if (authName === 'DASHBOARD_VIEW') return true;

    const foundPermission = permissionList.find(p => p.name === authName);
    return foundPermission ? foundPermission.hasPermission : false;
  } catch (error) {
    if (error.status === 404) {
      localStorage.clear();
    }
    return false;
  }
}

export default router
